<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-11-10 15:44:06
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-20 09:58:50
-->
<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 10:17:48
 * @LastEditors: xgx
 * @LastEditTime: 2022-11-10 11:30:33
-->
<template>
  <div>
    <div class="head">
      <div style="display: flex; align-items: center">
        <div class="back" @click="toBack"><a-icon type="arrow-left" /></div>
        <div style="font-size: 18px; color: #303133; font-weight: bold">
          &emsp;{{ itemId ? "详细信息" : "新增访谈" }}
        </div>
      </div>
    </div>
    <div class="top">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane
          v-if="codeData.indexOf('189') != -1"
          label="基本设置"
          name="first"
        ></el-tab-pane>
        <el-tab-pane
          v-if="itemId && codeData.indexOf('188') != -1"
          label="直播设置"
          name="second"
        ></el-tab-pane>
        <el-tab-pane
          v-if="itemId && codeData.indexOf('190') != -1"
          label="文字实录"
          name="third"
        ></el-tab-pane>
        <el-tab-pane
          v-if="itemId && codeData.indexOf('194') != -1"
          label="聊天室记录"
          name="fourth"
        ></el-tab-pane>
      </el-tabs>
    </div>
    <div class="content">
      <div v-if="type == 1">
        <el-form
          :model="collectForm"
          :rules="rules"
          ref="collectForm"
          label-width="100px"
          :style="{ height: height }"
          class="demo-ruleForm base_setting"
        >
          <el-form-item label="访谈主题">
            <el-input
              v-model="collectForm.interviewTheme"
              placeholder="请输入访谈主题"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否显示">
            <div class="status">
              <el-radio v-model="collectForm.displayStatus" :label="1"
                >显示</el-radio
              >
              <el-radio v-model="collectForm.displayStatus" :label="0"
                >不显示</el-radio
              >
            </div>
          </el-form-item>
          <el-form-item label="访谈摘要">
            <el-input
              placeholder="请输入访谈摘要"
              v-model="collectForm.interviewDigest"
              type="textarea"
              :rows="3"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="嘉宾信息">
            <el-input
              placeholder="请输入嘉宾信息"
              v-model="collectForm.guestIntroduction"
              type="textarea"
              :rows="3"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="访谈时间" prop="collectTime">
            <div class="block">
              <el-date-picker
                style="width: 100%"
                v-model="collectForm.collectTime"
                @input="selectTime"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期 时间"
                end-placeholder="结束日期 时间"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="主办单位">
            <el-input
              v-model="collectForm.hostUnit"
              placeholder="请输入主办单位"
            ></el-input>
          </el-form-item>
          <el-form-item label="展示封面">
            <a-upload
              name="avatar"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="false"
              :before-upload="beforeUpload"
            >
              <div
                class="box-img"
                style="width: 100%; height: 100%"
                v-if="imageUrl"
              >
                <img
                  style="width: 100%; height: 100%"
                  :src="imgIp + imageUrl"
                  alt="avatar"
                />
                <i
                  @click.stop="deletImg"
                  class="el-icon-close img-box-icon"
                ></i>
              </div>
              <div v-else>
                <a-icon :type="loading ? 'loading' : 'plus'" />
                <div class="ant-upload-text">上传图片</div>
              </div>
            </a-upload>
          </el-form-item>
          <el-form-item label="现场图片">
            <div style="display: flex">
              <div>
                <el-button
                  @click="openChooseCover"
                  style="height: 40px"
                  type="primary"
                  >选择图片</el-button
                >
                <div class="img-arry">
                  <div
                    v-for="(item, index) in coverImg"
                    class="img-box"
                    v-if="coverImg.length > 0"
                  >
                    <div class="semi-close" @click.stop="deleteImg(index)">
                      <span class="icon-semi-close"></span>
                    </div>
                    <img class="add-img" :src="imgIp + item" />
                    <div class="edit-image" @click="toEditImg(item, index)">
                      替换 编辑
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="font-size: 12px; margin-top: 0px">
              支持20MB以内的jpg、png图片
            </div>
          </el-form-item>
          <el-form-item label="现场视频">
            <a-upload
              name="avatar"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="false"
              :before-upload="beforeUploadTwo"
            >
              <div
                class="box-img"
                style="width: 100%; height: 100%"
                v-if="videoUrl"
              >
                <video
                  style="width: 100%; height: 100%"
                  :src="imgIp + videoUrl"
                  alt="avatar"
                />
                <i
                  @click.stop="deletVideo"
                  class="el-icon-close img-box-icon"
                ></i>
              </div>
              <div v-else>
                <span v-if="!loadingTwo" class="icon-field-9"></span>
                <a-icon v-if="loadingTwo" type="loading" />
                <div class="ant-upload-text">点击上传视频</div>
              </div>
            </a-upload>
          </el-form-item>
        </el-form>
        <div class="form-bottom base_btn">
          <el-button
            :loading="loadingSubmint"
            @click="saveCollect"
            size="medium"
            type="primary"
            >保存</el-button
          >
        </div>
      </div>
      <div style="margin-top: 22px" v-if="type == 2 && itemId">
        <el-form
          :model="collectForm"
          ref="collectForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="拉流地址">
            <el-input
              v-model="broadcastForm.pullFlowAddress"
              placeholder="请输入拉流地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="开启方式">
            <div class="status">
              <el-radio v-model="broadcastForm.openWay" label="0"
                >开启</el-radio
              >
              <el-radio v-model="broadcastForm.openWay" label="1"
                >关闭</el-radio
              >
              <el-radio v-model="broadcastForm.openWay" label="2"
                >定时开关</el-radio
              >
            </div>
            <div style="font-size: 12px">
              直播开启后,站点中"在线访谈"栏目将显示关于本次访谈的在线直播信息
            </div>
          </el-form-item>
          <el-form-item label="开关时间" prop="greyTime">
            <div class="block">
              <el-date-picker
                v-model="broadcastForm.collectTime"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期 时间"
                end-placeholder="结束日期 时间"
              >
              </el-date-picker>
            </div>
            <div style="font-size: 12px">
              设置定时开关时间后，将自动在该时间内显示在线直播信息
            </div>
          </el-form-item>
          <el-form-item class="bottom">
            <div class="form-bottom">
              <el-button
                :loading="loadingSubmintBroadcast"
                @click="saveCollectTwo"
                size="medium"
                type="primary"
                >保存</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div style="margin-top: 22px" v-if="type == 3 && itemId">
        <div class="written-title">文字实录清单</div>
        <a-spin :spinning="wordLoading">
          <div class="written-transcript">
            <div :style="{ height: height }" class="left">
              <el-timeline :reverse="reverse">
                <el-timeline-item
                  v-for="(activity, index) in writtenList"
                  :key="index"
                  :icon="'icon-time-line'"
                >
                  <div class="written-one">
                    <div class="written-name">
                      <div
                        v-if="writtenItem.id != activity.id"
                        style="margin-right: 20px"
                      >
                        {{ activity.spokesperson }}
                      </div>
                      <div v-if="writtenItem.id != activity.id">
                        时间: {{ activity.speakTime }}
                      </div>
                      <el-input
                        v-if="writtenItem.id == activity.id"
                        v-model="itemForm.spokesperson"
                        :placeholder="activity.spokesperson"
                        style="margin-right: 20px"
                      ></el-input>
                      <el-input
                        v-if="writtenItem.id == activity.id"
                        v-model="itemForm.speakTime"
                        :placeholder="activity.speakTime"
                      ></el-input>
                    </div>
                    <div>
                      <a
                        v-if="
                          writtenItem.id != activity.id &&
                          codeData.indexOf('193') != -1
                        "
                        @click="reacordEdit(activity)"
                        >编辑</a
                      >
                      <a
                        v-if="
                          writtenItem.id == activity.id &&
                          codeData.indexOf('193') != -1
                        "
                        @click="saveItem(activity)"
                        >保存</a
                      >
                      <a
                        v-if="codeData.indexOf('192') != -1"
                        @click="deleteWritten(activity)"
                        style="color: #f56c6c; margin-left: 10px"
                        >删除</a
                      >
                    </div>
                  </div>
                  <div class="written-content">
                    <div v-if="writtenItem.id != activity.id">
                      {{ activity.speakDetails }}
                    </div>
                    <div v-if="writtenItem.id == activity.id" class="fayan">
                      <el-input
                        type="textarea"
                        v-model="itemForm.speakDetails"
                        rows="5"
                      >
                      </el-input>
                    </div>
                  </div>
                </el-timeline-item>
              </el-timeline>
            </div>
            <div class="right">
              <div class="right-title">预设信息(可在实录中引用)</div>
              <div class="right-box" :style="{height:heightThree}">
                <div class="add-input">
                  <el-input placeholder="请输入内容" v-model="input2">
                    <template slot="append"
                      ><div
                        @click="addRecord"
                        style="width: 100%; height: 100%; cursor: pointer"
                      >
                        添加
                      </div></template
                    >
                  </el-input>
                </div>
                <div class="box-reacod">
                  <div v-for="(item, index) in recordData" class="reacod-style">
                    <span :title="item">{{ item }}</span
                    ><span
                      @click="deletePreon(index)"
                      style="color: #fff"
                      class="icon-field-close"
                    ></span>
                  </div>
                </div>
                <div>
                  <el-form
                    :model="recordForm"
                    ref="collectForm"
                    class="record-data"
                  >
                    <el-form-item label="发言人">
                      <el-select
                        v-model="recordForm.spokesperson"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="item in recordData"
                          :key="item"
                          :label="item"
                          :value="item"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="发言时间">
                      <div class="time-style">
                        <el-date-picker
                          v-model="recordForm.speakTime"
                          type="date"
                          value-format="yyyy-MM-dd hh:ss:mm"
                          placeholder="选择日期"
                        >
                        </el-date-picker>
                        <div @click="addTime" class="add-time">当前时间</div>
                      </div>
                    </el-form-item>
                  </el-form>
                  <div class="fayan">
                    <el-input
                      type="textarea"
                      placeholder="请输入发言内容"
                      v-model="recordForm.speakDetails"
                      rows="15"
                    >
                    </el-input>
                  </div>
                </div>
              </div>
              <div class="btn">
                  <el-button
                    v-if="codeData.indexOf('191') != -1"
                    style="cursor: pointer"
                    @click="addFactual"
                    type="primary"
                    >添加实录</el-button
                  >
                </div>
            </div>
          </div>
        </a-spin>
      </div>
      <div v-if="type == 4 && itemId">
        <coententTable
          @onShowSizeChange="onShowSizeChange"
          :columns="columns"
          :pagination="pagination"
          :dataSource="dataSource"
          :customSlot="customSlot"
          :loading="listLoading"
          :y="heightTwo"
          @handleSizeChange="handleSizeChange"
        >
          <template v-slot:isLogin="scopeVal">
            <div>
              {{ scopeVal.scope.isLogin ? "是" : "否" }}
            </div>
          </template>
          <template v-slot:operation="scopeVal">
            <div style="display: flex">
              <div
                v-if="
                  scopeVal.scope.taboo == 1 && codeData.indexOf('260') != -1
                "
                @click="toTaboo(scopeVal.scope, 0)"
                style="margin-right: 14px; width: 96px"
                class="btnTwo"
              >
                解除本次禁言
              </div>
              <div
                v-if="
                  scopeVal.scope.taboo == 2 && codeData.indexOf('261') != -1
                "
                @click="toTaboo(scopeVal.scope, 0)"
                style="margin-right: 14px; width: 96px"
                class="btnTwo"
              >
                解除永久禁言
              </div>
              <div
                v-if="
                  scopeVal.scope.taboo == 0 && codeData.indexOf('258') != -1
                "
                @click="toTaboo(scopeVal.scope, 1)"
                style="margin-right: 14px; width: 66px"
                class="btnTwo"
              >
                本次禁言
              </div>
              <div
                v-if="
                  scopeVal.scope.taboo == 0 && codeData.indexOf('259') != -1
                "
                @click="toTaboo(scopeVal.scope, 2)"
                class="btnTwo"
                style="margin-right: 14px; width: 66px"
              >
                永久禁言
              </div>
              <div
                v-if="codeData.indexOf('257') != -1"
                @click="deleteTaboo(scopeVal.scope)"
                class="btnThree"
              >
                删除
              </div>
            </div>
          </template>
        </coententTable>
      </div>
    </div>
    <choose-cover
      :resourceIsShow="resourceIsShow"
      @colseChooseCover="colseChooseCover"
      ref="chooseCover"
      @setCoverImg="setCoverImg"
      name="上传图片"
      :imgPathEidt="imgPath"
      v-if="resourceIsShow"
    ></choose-cover>
  </div>
</template>
<script>
import coententTable from "@/components/coentent_table.vue";
import chooseCover from "../../Content/Manuscripts/chooseCover.vue";
import { uploadImg } from "@/utils/common.js";
import {
  saveInterview,
  saveLiveSet,
  findLiveSet,
  getDelOnline,
  updateInterview,
  updateLiveSet,
  chatRoomList,
  updateTaboo,
  saveWordMemoir,
  findWordMemoirList,
  updateWordMemoir,
  deleteWordMemoir,
  delChatMessageOne,
} from "./online_interview";
import { message } from "ant-design-vue";
export default {
  components: {
    coententTable,
    chooseCover,
  },
  data() {
    return {
      type: 1,
      reverse: true,
      height: 0,
      input2: "",
      recordData: [],
      recordForm: {},
      activities: [
        {
          content: "活动按期开始",
          timestamp: "2018-04-15",
        },
        {
          content: "通过审核",
          timestamp: "2018-04-13",
        },
        {
          content: "创建成功",
          timestamp: "2018-04-11",
        },
      ],
      collectForm: {},
      resourceIsShow: false,
      coverImg: [],
      loadingSubmint: false,
      imgPath: "",
      imageUrl: "",
      videoUrl: "",
      loading: false,
      itemId: "",
      broadcastForm: {},
      loadingSubmintBroadcast: false,
      loadingSubmint: false,
      columns: [
        {
          title: "网友名称",
          dataIndex: "userName",
          width: 120,
          ellipsis: true,
        },
        {
          title: "IP地址",
          dataIndex: "ipAddress",
          width: 300,
          ellipsis: true,
        },
        {
          title: "是否登录",
          dataIndex: "isLogin",
          scopedSlots: { customRender: "isLogin" },
          width: 120,
          ellipsis: true,
        },
        {
          title: "留言时间",
          dataIndex: "messageTime",
          width: 200,
          ellipsis: true,
        },
        {
          title: "留言内容",
          dataIndex: "messageContents",
          ellipsis: true,
          customCell: (column) => {
            return {
              style: {
                "min-width": "220px",
                "max-width": "400px",
              },
            };
          },
          customHeaderCell: (column) => {
            return {
              style: {
                "min-width": "220px",
                "max-width": "400px",
              },
            };
          },
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          width: 260,
          fixed: "right",
        },
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ["10", "20", "30"],
      },
      dataSource: [],
      customSlot: [
        {
          name: "isLogin",
          customRender: "isLogin",
        },
      ],
      listLoading: false,
      writtenList: [],
      writtenItem: {},
      itemForm: {},
      loadingTwo: false,
      activeName: "first",
      wordLoading: false,
      height: 0,
      selectIndex: 0,
      isReplace: false,
      codeData: [],
      heightThree: false,
      rules: {
        collectTime: [
          { required: true, message: "请选择访谈时间", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.itemId = this.$route.query.isCollectId;
    this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
    if (
      this.codeData.indexOf("189") == -1 &&
      this.codeData.indexOf("188") == -1 &&
      this.codeData.indexOf("190") == -1
    ) {
      this.activeName = "fourth";
      this.type = 4;
      this.changeType(this.type);
      return;
    } else if (
      this.codeData.indexOf("189") == -1 &&
      this.codeData.indexOf("188") == -1
    ) {
      this.activeName = "third";
      console.log(this.type, "ss");
      this.type = 3;
      this.changeType(this.type);
      return;
    } else if (this.codeData.indexOf("189") == -1) {
      this.activeName = "second";
      this.type = 2;
      this.changeType(this.type);
      return;
    } else {
      this.activeName = "first";
      this.type = 1;
      this.changeType(this.type);
    }
    if (this.itemId) {
      this.getDelCollect();
    }
    this.height = document.documentElement.clientHeight - 360 + "px";
    this.heightThree = document.documentElement.clientHeight - 450 + "px";
    window.onresize = () => {
      return (() => {
        this.height = document.documentElement.clientHeight - 360 + "px";
        this.heightThree = document.documentElement.clientHeight - 450 + "px";
      })();
    };
  },
  methods: {
    deletImg() {
      this.imageUrl = "";
    },
    deletVideo() {
      this.videoUrl = "";
    },
    handleClick() {
      if (this.activeName == "first") {
        this.type = 1;
        this.changeType(1);
      }
      if (this.activeName == "second") {
        this.type = 2;
        this.changeType(2);
      }
      if (this.activeName == "third") {
        this.type = 3;
        this.changeType(3);
      }
      if (this.activeName == "fourth") {
        this.type = 4;
        this.changeType(4);
      }
    },
    selectTime() {
      this.collectForm = JSON.parse(JSON.stringify(this.collectForm));
    },
    deleteTaboo(item) {
      delChatMessageOne({
        id: item.id,
      }).then((res) => {
        if (res.code == 0) {
          this.getChatList();
        }
      });
    },
    deleteWritten(item) {
      deleteWordMemoir({
        id: item.id,
      }).then((res) => {
        if (res.code == 0) {
          this.getWrittenList();
        }
      });
    },
    saveItem(item) {
      updateWordMemoir({
        id: item.id,
        ...this.itemForm,
      }).then((res) => {
        if (res.code == 0) {
          this.writtenItem = {};
          this.getWrittenList();
        }
      });
    },
    reacordEdit(item) {
      this.writtenItem = item;
      this.itemForm = item;
    },
    deletePreon(index) {
      this.recordData.splice(index, 1);
    },
    getWrittenList() {
      this.wordLoading = true;
      findWordMemoirList({
        id: this.itemId,
      }).then((res) => {
        if (res.code == 0) {
          this.writtenList = JSON.parse(JSON.stringify(res.data));
          this.wordLoading = false;
        }
      });
    },
    addFactual() {
      saveWordMemoir({
        isInterviewId: this.itemId,
        ...this.recordForm,
      }).then((res) => {
        if (res.code == 0) {
          this.recordForm = {};
          this.getWrittenList();
          this.input2 = "";
        }
      });
    },
    addTime() {
      this.recordForm.speakTime = this.farmatDate(new Date(), "-");
      this.recordForm = JSON.parse(JSON.stringify(this.recordForm));
    },
    addRecord() {
      this.recordData.push(this.input2);
      this.recordData = this.removeDuplicate(this.recordData);
      this.input2 = "";
    },
    removeDuplicate(arr) {
      const newArr = [];
      arr.forEach((item) => {
        if (newArr.indexOf(item) === -1) {
          newArr.push(item);
        }
      });
      return newArr; // 返回一个新数组
    },
    getChatList() {
      this.listLoading = true;
      chatRoomList({
        current: this.pagination.current,
        isInterviewId: this.itemId,
        size: this.pagination.pageSize,
      }).then((res) => {
        if (res.code == 0) {
          this.dataSource = res.data.records;
          if (this.dataSource.length > 0) {
            this.heightTwo = document.documentElement.clientHeight - 360 + "px";
            window.onresize = () => {
              return (() => {
                this.heightTwo =
                  document.documentElement.clientHeight - 360 + "px";
              })();
            };
          }
          this.listLoading = false;
        }
      });
    },
    toTaboo(item, type) {
      updateTaboo({
        id: item.id,
        taboo: type,
      }).then((res) => {
        if (res.code == 0) {
          this.getChatList();
        }
      });
    },
    saveCollect() {
      this.loadingSubmint = true;
      this.collectForm.localePhoto = this.coverImg.join(",");
      this.collectForm.cover = this.imageUrl;
      this.collectForm.localeVideo = this.videoUrl;
      this.$refs.collectForm.validate((valid) => {
        if (valid) {
          if (this.collectForm.collectTime) {
            this.collectForm.interviewStartTime = this.farmatDate(
              new Date(this.collectForm.collectTime[0].toString()).getTime(),
              "-"
            );
            this.collectForm.interviewEndTime = this.farmatDate(
              new Date(this.collectForm.collectTime[1].toString()).getTime(),
              "-"
            );
          }
          this.collectForm.collectTime = "";
          if (this.itemId) {
            updateInterview({
              siteId: sessionStorage.getItem("siteId"),
              ...this.collectForm,
            }).then((res) => {
              if (res.code == 0) {
                message.success("编辑成功");
                this.getDelCollect();
              }
              this.loadingSubmint = false;
            });
          } else {
            saveInterview({
              siteId: sessionStorage.getItem("siteId"),
              ...this.collectForm,
            }).then((res) => {
              if (res.code == 0) {
                this.itemId = res.data.id;
                message.success("保存成功");
                this.getDelCollect();
              }
              this.loadingSubmint = false;
            });
          }
        } else {
          this.loadingSubmint = false;
        }
      });
    },
    getDelCollect() {
      getDelOnline({
        id: this.itemId,
      }).then((res) => {
        if (res.code == 0) {
          this.collectForm = res.data;
          this.videoUrl = res.data.localeVideo;
          if (res.data.localePhoto) {
            this.coverImg = res.data.localePhoto.split(",");
          }
          this.imageUrl = res.data.cover;
          this.collectForm.collectTime = [
            new Date(this.collectForm.interviewStartTime),
            new Date(this.collectForm.interviewEndTime),
          ];
        }
      });
    },
    getDelBroadcast() {
      findLiveSet({
        id: this.itemId,
      }).then((res) => {
        if (res.code == 0 && res.data) {
          this.broadcastForm = res.data;
          this.broadcastForm.openWay = `${res.data.openWay}`;
          this.broadcastForm.collectTime = [
            new Date(this.broadcastForm.switchStartTime),
            new Date(this.broadcastForm.switchEndTime),
          ];
        }
      });
    },
    saveCollectTwo() {
      this.loadingSubmintBroadcast = true;
      if (this.broadcastForm.collectTime) {
        this.broadcastForm.switchStartTime = this.farmatDate(
          new Date(this.broadcastForm.collectTime[0].toString()).getTime(),
          "-"
        );
        this.broadcastForm.switchEndTime = this.farmatDate(
          new Date(this.broadcastForm.collectTime[1].toString()).getTime(),
          "-"
        );
      }
      this.broadcastForm.collectTime = "";
      if (this.broadcastForm.id) {
        updateLiveSet({
          isInterviewId: this.itemId,
          ...this.broadcastForm,
        }).then((res) => {
          if (res.code == 0) {
            message.success("保存成功");
            this.getDelBroadcast();
          }
          this.loadingSubmintBroadcast = false;
        });
      } else {
        saveLiveSet({
          isInterviewId: this.itemId,
          ...this.broadcastForm,
        }).then((res) => {
          if (res.code == 0) {
            message.success("保存成功");
            this.getDelBroadcast();
          }
          this.loadingSubmintBroadcast = false;
        });
      }
    },
    async beforeUpload(file) {
      if (["image/jpeg", "image/png", "image/jpg"].indexOf(file.type) == -1) {
        this.$message.error("封面只能上传 png/jpg 格式!");
        return;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
      }
      this.loading = true;
      let imgData = await uploadImg(file, "column_management");
      this.imageUrl = imgData.path;
      this.loading = false;
      return false;
    },
    async beforeUploadTwo(file) {
      if (
        [
          "video/mp4",
          "video/mov",
          "video/rmvb",
          "video/3gp",
          "video/wmv",
          "video/m4v",
        ].indexOf(file.type) == -1
      ) {
        this.$message.error("视频只能上传 mp4/mov/rmvb/3gp/wmv/m4v 格式!");
        return;
      }
      this.loadingTwo = true;
      let imgData = await uploadImg(file, "column_management");
      this.videoUrl = imgData.path;
      this.loadingTwo = false;
      return false;
    },
    farmatDate(date, cut) {
      var date = new Date(date);
      var YY = date.getFullYear() + cut;
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + cut;
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + " " + hh + mm + ss;
    },
    openChooseCover() {
      this.resourceIsShow = true;
      this.isReplace = false;
      this.imgPath = "";
    },
    colseChooseCover() {
      this.resourceIsShow = false;
    },
    setCoverImg(imgUrl) {
      if (this.isReplace) {
        this.coverImg[this.selectIndex] = imgUrl;
      } else {
        this.coverImg.push(imgUrl);
      }
      this.coverImg = this.coverImg.filter(function (s) {
        return s && s.trim();
      });
      this.coverImg = this.removeDuplicate(this.coverImg);
    },
    deleteImg(index) {
      this.coverImg.splice(index, 1);
    },
    removeDuplicate(arr) {
      const newArr = [];
      arr.forEach((item) => {
        if (newArr.indexOf(item) === -1) {
          newArr.push(item);
        }
      });
      return newArr; // 返回一个新数组
    },
    toBack() {
      this.$router.push({
        path: "/index/interaction/online_interview",
      });
    },
    toEditImg(item, index) {
      this.isReplace = true;
      this.selectIndex = index;
      this.imgPath = item;
      this.resourceIsShow = true;
    },
    changeType(type) {
      this.type = type;
      if (type == 1 && this.itemId) {
        this.getDelCollect();
      }
      if (type == 2 && this.itemId) {
        this.getDelBroadcast();
      }
      if (type == 3 && this.itemId) {
        this.getWrittenList();
      }
      if (type == 4 && this.itemId) {
        this.getChatList();
      }
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.getChatList();
    },
    handleSizeChange(pageSize) {
      this.pagination.current = 1;
      this.pagination.pageSize = pageSize;
      this.getChatList();
    },
  },
};
</script>

<style lang="less" scoped>
.top {
  padding: 24px;
  padding-bottom: 0px;
  .log-box {
    border-bottom: solid 1px #dcdfe6;
    display: flex;
    color: #000;
    .log {
      padding: 10px 20px;
      border-top: solid 1px #dcdfe6;
      border-left: solid 1px #dcdfe6;
      cursor: pointer;
    }
    .log:last-child {
      border-right: solid 1px #dcdfe6;
      border-top-right-radius: 10px;
    }
    .log:first-child {
      border-top-left-radius: 10px;
    }
  }
}
.head {
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #dcdfe6;
  padding: 18px 24px;
}
.content {
  padding-left: 24px;
  .demo-ruleForm {
    width: 600px;
    padding-left: 24px;
  }
  .tips-text {
    font-size: 12px;
    // height: 20px;
    line-height: 26px;
    color: #9093a6;
  }
  /deep/ .el-form-item__label {
    text-align: left;
    width: 100px !important;
  }
  /deep/ .el-form-item__content {
    margin-left: 100px !important;
  }
  /deep/ .el-upload--picture-card {
    width: 80px;
    height: 80px;
    line-height: 80px;
    border: none;
    img {
      width: 80px;
      height: 80px;
    }
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
    line-height: 80px;
  }
  .status {
    border: solid 1px #dcdfe6;
    border-radius: 4px;
    padding-left: 10px;
  }
}
.choose_template {
  /deep/.el-dialog__title {
    font-size: 16px;
    font-weight: bold;
  }
  /deep/.el-dialog {
    width: 36%;
  }
  .lod-tips {
    background: #f7f7f7;
    font-size: 12px;
    color: #928f8f;
    line-height: 36px;
    padding: 0 10px;
    border-radius: 4px;
  }
  .choose-path {
    line-height: 50px;
    padding: 0 10px;
    border-radius: 4px;
    border: solid 1px #dcdfe6;
    margin-top: 20px;
    box-sizing: border-box;
  }
  .template-list {
    border: solid 1px #dcdfe6;
    border-radius: 4px;
    margin-top: 20px;

    .title {
      background: #f7f7f7;
    }
    .item {
      font-weight: bold;
      line-height: 52px;
      box-sizing: border-box;
      border-bottom: solid 1px #dcdfe6;
      padding: 0 10px;
      &:last-child {
        border: none;
      }
    }
  }
}
.add-uplaod {
  width: 43px;
  height: 40px;
  background-color: #f6f6f6;
  border-radius: 4px;
  text-align: center;
  border: 1px solid #dcdfe6;
  margin-left: 10px;
}
.edit-image {
  position: absolute;
  background: #858383;
  width: 50%;
  height: 30px;
  line-height: 30px;
  margin: 0 auto;
  border-radius: 5px;
  cursor: pointer;
  bottom: 8px;
  right: 25%;
  // margin-left: -30px;
  color: #fff;
  font-size: 12px;
  text-align: center;
}
.semi-close {
  position: absolute;
  top: -8px;
  right: -7px;
  width: 20px;
  height: 20px;
  background-color: rgba(144, 147, 153, 1);
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.img-box {
  position: relative;
  width: 154px;
  height: 120px;
  margin-top: 20px;
  margin-right: 20px;
  .add-img {
    width: 100%;
    height: 100%;
  }
}
.img-arry {
  display: flex;
}
.back {
  cursor: pointer;
}
.written-transcript {
  display: flex;
  .left {
    flex: 1;
    overflow-y: auto;
    padding: 20px;
    .written-content {
      border-radius: 2px;
      background-color: rgba(247, 247, 249, 1);
      color: rgba(16, 16, 16, 1);
      font-size: 14px;
      padding: 14px;
      margin-top: 14px;
    }
  }
  .right {
    width: 462px;
    background: #fff;
    margin-left: 24px;
    margin-right: 24px;
    border: solid 2px #d9d9d9;
    border-radius: 6px;
    overflow-y: auto;
  }
}
.written-title {
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 20px;
}
.written-one {
  display: flex;
  justify-content: space-between;
  .written-name {
    display: flex;
  }
}
/deep/ .el-timeline-item__icon {
  color: #fff;
  font-size: 18px;
  background: #fff;
}
/deep/ .el-timeline-item__node--normal {
  left: -1px;
  top: -7px;
}
.right-title {
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
  border-radius: 6px 6px 0px 0px;
  background-color: rgba(247, 247, 247, 1);
  height: 56px;
  line-height: 56px;
  padding-left: 18px;
  border-bottom: solid 2px #d9d9d9;
  font-weight: 600;
}
/deep/ .el-timeline {
  padding-left: 0px;
}
.add-input {
  padding: 24px;
}
.reacod-style {
  border-radius: 20px;
  background-color: rgba(245, 247, 250, 1);
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(220, 223, 230, 1);
  padding: 7px 16px 7px 10px;
  max-width: 154px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  margin-right: 12px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  .icon-field-close:before {
    color: #a9aab1;
    font-size: 18px;
    margin-left: 20px;
  }
}
.box-reacod {
  display: flex;
  padding: 0 24px;
  flex-wrap: wrap;
}
.record-data {
  padding: 20px 24px;
  border-radius: 2px;
  padding-bottom: 1px;
  background-color: rgba(247, 247, 249, 1);
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
  /deep/ .el-form-item__label {
    width: 80px !important;
  }
  /deep/ .el-form-item__content {
    margin-left: 81px !important;
  }
  /deep/ .el-select {
    width: 100%;
  }
}
.fayan {
  /deep/ .el-textarea__inner {
    border: none !important;
    resize: none;
    outline: none;
  }
}
.btn {
  margin-bottom: 24px;
  margin-right: 24px;
  text-align: right;
  right: 24px;
  bottom: 0;
}
.time-style {
  display: flex;
  border: solid 1px rgba(220, 223, 230, 1);
  /deep/ .el-input__inner {
    outline: none;
    border: none;
  }
}
.add-time {
  border-radius: 0px 4px 4px 0px;
  background-color: rgba(245, 247, 250, 1);
  color: rgba(48, 49, 51, 1);
  font-size: 14px;
  height: 100%;
  text-align: center;
  font-family: Roboto;
  border-left: 1px solid rgba(220, 223, 230, 1);
  width: 100px;
  cursor: pointer;
}
.base_setting {
  width: 800px;
  overflow-y: auto;
  padding: 24px;
}
.base_btn {
  position: absolute;
  bottom: 0;
  padding: 24px;
}
/deep/ .table {
  margin-left: 0px;
}
/deep/ .el-tabs__header {
  margin: 0px;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.box-img {
  position: relative;
  .img-box-icon {
    position: absolute;
    top: -6px;
    right: -8px;
    font-size: 16px;
    font-weight: bold;
  }
}
.el-button--primary {
  background: #176de6;
}
.right-box{
  padding-bottom: 20px;
  overflow-y: auto;
}
</style>